import React, { useCallback, useContext } from "react";

import { Link } from "@plex/react-components";

import { DialogNavigationContext, IDialogRouteProps } from ".";

export interface IDialogLinkProps {
  onClick?: () => void;
  route: IDialogRouteProps;
}

export const DialogLink: React.FC<IDialogLinkProps> = ({ onClick, route, children }) => {
  const dialogNavigationContext = useContext(DialogNavigationContext);

  const onLinkClick = useCallback(
    args => {
      args.preventDefault();
      onClick && onClick();

      dialogNavigationContext.showDialog(route);
    },
    [route, dialogNavigationContext, onClick]
  );

  return <Link onClick={onLinkClick}>{children}</Link>;
};
